import { xor } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { navigateToChangeInsightDetails } from '../../links/index.jsx';

const StakeholdersGroupFilter = ({
  initiativeStakeholders,
  selectedInitiativeStakeholderIds,
  initiativeId,
  initiativeType,
}) => {
  const selectedCount = selectedInitiativeStakeholderIds.length;

  const filteredByType = (objectType) =>
    [
      ...initiativeStakeholders,
      { id: 'none', fullName: 'None', objectType: 'individual' },
    ].filter((stakeholder) => stakeholder.objectType === objectType);

  const handleSelect = useCallback(
    (organizationStakeholderId) => {
      // Handle numeric IDs and special 'none' value
      if (!organizationStakeholderId || organizationStakeholderId === 'none') {
        return navigateToChangeInsightDetails(
          {
            organizationStakeholderIds: xor(selectedInitiativeStakeholderIds, [
              'none',
            ]),
          },
          initiativeId,
          initiativeType
        );
      }

      const numericId = parseInt(organizationStakeholderId, 10);
      return navigateToChangeInsightDetails(
        {
          organizationStakeholderIds: xor(selectedInitiativeStakeholderIds, [
            numericId,
          ]),
        },
        initiativeId,
        initiativeType
      );
    },
    [selectedInitiativeStakeholderIds, initiativeId, initiativeType]
  );

  const renderMenuItems = useCallback(
    (objectType) =>
      filteredByType(objectType).map((stakeholder) => {
        const active = selectedInitiativeStakeholderIds.includes(
          stakeholder.id === 'none' ? 'none' : stakeholder.id
        );

        return (
          <React.Fragment key={stakeholder.id}>
            <MenuItem
              onSelect={handleSelect}
              active={active}
              eventKey={stakeholder.id.toString()}
            >
              <span>{stakeholder.fullName}</span>
            </MenuItem>
          </React.Fragment>
        );
      }),
    [selectedInitiativeStakeholderIds, initiativeStakeholders]
  );

  return (
    <div className="" style={{ flex: 1 }}>
      <div className="text-muted filter-label">
        Stakeholder Group / Individual
      </div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="statuses-filter"
          className="btn-block"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>
          <MenuItem divider />
          <MenuItem header>Group</MenuItem>
          {renderMenuItems('group')}
          <MenuItem divider />
          <MenuItem header>Individual</MenuItem>
          {renderMenuItems('individual')}
          <MenuItem divider />
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
};

StakeholdersGroupFilter.propTypes = {
  initiativeStakeholders: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  selectedInitiativeStakeholderIds: PropTypes.arrayOf(PropTypes.number),
};

StakeholdersGroupFilter.defaultProps = {
  initiativeStakeholders: [],
  selectedInitiativeStakeholderIds: [],
};

export default StakeholdersGroupFilter;
